import api from './api';

export interface ActivityLogEntry {
  id: string;
  createdAt: string;
  type: string;
  title: string;
  icon: string | null;
  data?: Record<string, unknown>;
}

export const getUserActivity = async (limit = 10): Promise<ActivityLogEntry[]> => {
  const params = new URLSearchParams({ limit: String(limit) });
  return await api.get<ActivityLogEntry[]>(`/activity?${params.toString()}`);
};
